import api from "../../config/http-common";

const generateAuthenticationCode = (payload) => {
  return api
    .securedAxios()
    .post("/web/api/v4/users/loginAuthentication/code", payload);
};

const validateAuthenticationCode = (payload) => {
  console.log(payload);
  return api
    .unsecuredAxios()
    .put(
      "/web/api/v4/users/loginAuthentication/codes/" + payload.code,
      payload,
    );
};

const getLoginAuthenticationDetails = (payload) => {
  return api
    .securedAxios()
    .get(
      "/web/api/v4/users/loginAuthentication/codes/" +
        payload.email +
        "?loginSecurityKey=" +
        payload.loginSecurityKey,
    );
};

const generateAuthenticationOTPResend = (payload) => {
  return api
    .unsecuredAxios()
    .post("/web/api/v4/users/loginAuthentication/otp/resend", payload);
};

const LoginAuthenticationService = {
  generateAuthenticationCode,
  validateAuthenticationCode,
  getLoginAuthenticationDetails,
  generateAuthenticationOTPResend,
};

export default LoginAuthenticationService;
